import { CSSObject } from '@emotion/react';
import { keyframes } from '@emotion/react';
import { mobile } from 'styles/media';
import * as zIndex from 'styles/zIndex';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const wrap: CSSObject = {
  position: 'fixed',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  inset: 0,
  padding: 20,
  boxSizing: 'border-box',
  background: 'rgba(0, 0, 0, 0.45)',
  zIndex: zIndex.BACKGROUND,
  animation: `${fadeIn} 0.15s ease-out`,
  [mobile]: {
    padding: 16,
  },
};

export { wrap };
